import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function getDateString(string) {
  const date = new Date(string);

  const year = date.getFullYear();
  const month = date.toLocaleString("de-at", { month: "long" });
  const day = date.getDate();

  return `${day}. ${month} ${year}`;
}

const Parent = ({ link, children, image }) => {
  if (link) {
    return (
      <Link className={image ? "sm:row-span-2 cursor-pointer" : ""} to={link}>
        {children}
      </Link>
    );
  } else {
    return <div className={image ? "sm:row-span-2" : ""}>{children}</div>;
  }
};

export default function Card({
  title,
  subtitle,
  content,
  children,
  image,
  noShadow,
  category,
  link,
  loading,
  date,
  author,
}) {
  return (
    <Parent link={link} image={image}>
      <div
        className={`bg-white rounded h-full ${
          noShadow ? "" : "shadow-lg hover:shadow-2xl transition-shadow"
        }`}
      >
        <div className="flex flex-col h-full">
          {image && (
            <GatsbyImage
              image={image.childImageSharp.gatsbyImageData}
              loading={loading || "lazy"}
              className="rounded-t"
              alt={title}
            />
          )}

          <div className="max-w-none p-6">
            {category && <p className="text-indigo-600 mb-2">{category}</p>}
            <h2 className="font-bold text-2xl mb-3">{title}</h2>
            {subtitle && <h3 className="">{subtitle}</h3>}
            <div className="prose text-lg text-gray-600">
              {content ? (
                <div dangerouslySetInnerHTML={{ __html: content }} />
              ) : (
                <div>{children}</div>
              )}
            </div>
          </div>
          <div className="my-auto" />
          {date && author && (
            <div className="px-6 pb-6">
              <p>{author}</p>
              <p className="text-gray-600">{getDateString(date)}</p>
            </div>
          )}
        </div>
      </div>
    </Parent>
  );
}
